import usePermission from "../Util/usePermissions.js";
import NoAccess from "./NoAccess.jsx";

export default function Protected({ permission, deny, children }) {
    const { hasPermission, hasAnyPermission } = usePermission();

    // `permission` may be a single string or an array (any-of).
    const ok = Array.isArray(permission)
        ? hasAnyPermission(permission)
        : hasPermission(permission);

    // `deny` is a "deny-flag": if the user HAS it, access is blocked.
    // May be a single slug or an array (any-of blocks).
    const denied = deny
        ? (Array.isArray(deny) ? hasAnyPermission(deny) : hasPermission(deny))
        : false;

    if (!ok || denied) {
        return <NoAccess permission={denied ? null : permission} />;
    }

    return children;
}
